import styled from 'styled-components';

export const Container = styled.div`
  max-width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const PageContentWrapperDesktop = styled.div`
  display: grid;
  grid-template-columns: 280px 1fr;
  grid-template-areas: 'breadCrumb breadCrumb' 'menu content';
  padding: 0 20px;
  max-width: 100%;
`;
export const PageContentWrapperMobile = styled.div`
  display: grid;
  padding: 0px;
  grid-template-columns: 1fr;
  grid-template-areas: 'breadCrumb' 'menu' 'content';
  max-width: 100%;
`;

export const MenuContainerDesktop = styled.div`
  grid-area: content;
  width: 960px;
`;
export const MenuContainerMobile = styled.div`
  grid-area: content;
  width: 960px;
  max-width: 100vw;
`;
export const SetairPromotionsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 283px);
  grid-column-gap: 10px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    overflow-x: scroll;
  }
`;
